import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

type useLayerLoginProps = {
  forceLogin?: boolean;
  returnTo?: string;
};

export default function useLayerLogin({
  forceLogin = false,
  returnTo,
}: useLayerLoginProps = {}) {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const [searchParams] = useSearchParams();
  const { connection } = Object.fromEntries(searchParams);

  if (returnTo === undefined) {
    returnTo = `${window.location.pathname}${window.location.search}`;
  }

  useEffect(() => {
    if (isLoading || (isAuthenticated && !forceLogin)) {
      return;
    }
    loginWithRedirect({
      authorizationParams: {
        prompt: "select_account",
        connection,
      },
      appState: { returnTo },
    });
  }, [isLoading, isAuthenticated, loginWithRedirect, connection, returnTo]);
  return {
    isAuthenticated,
  };
}
